import { render } from "./DarkCard.vue?vue&type=template&id=284c0729&scoped=true"
const script = {}

import "./DarkCard.vue?vue&type=style&index=0&id=284c0729&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284c0729"]])

export default __exports__